export default "__VITE_ASSET__CsRcjseK__"